import { supabase } from "@/lib/supabase";
import { useEffect, useState } from "react";

export interface RecipeSuggestion {
  label: string;
  url: string;
}

/**
 * Fetches suggested recipe URLs from the parsed-recipe cache (entries marked suggested).
 * Used on the import screen for "Try a random recipe". Falls back to empty if fetch fails.
 */
export function useRecipeSuggestions(): RecipeSuggestion[] {
  const [suggestions, setSuggestions] = useState<RecipeSuggestion[]>([]);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data, error } = await supabase.functions.invoke("get-recipe-suggestions");
        if (cancelled || data?.error || error) return;
        const list = data?.data?.suggestions;
        if (Array.isArray(list) && list.length > 0) {
          const valid: RecipeSuggestion[] = list
            .filter((s: unknown): s is { label?: string; url: string } => !!s && typeof s === "object" && typeof (s as { url?: string }).url === "string")
            .map((s) => ({ label: typeof s.label === "string" ? s.label : s.url, url: s.url }));
          setSuggestions(valid);
        }
      } catch {
        // Leave suggestions empty; UI will use static fallback
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return suggestions;
}
